import { module } from 'angular';
import templateBuilderNumberDisplay from './builder/display.html';
import templateBuilderNumberData from './builder/data.html';
import templateBuilderNumberValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/number/display.html', templateBuilderNumberDisplay);
	$templateCache.put('kform/components/number/data.html', templateBuilderNumberData);
	$templateCache.put('kform/components/number/validate.html', templateBuilderNumberValidate);
});
